import { ExternalLink } from 'lucide-react';

const PriceTable = () => {
  const removalCost = "115,000円～";
  
  const priceData = [
    { size: "１㎡以内", cost: "180,000円", unitCost: "～230,000円" },
    { size: "２㎡以内", cost: "230,000円", unitCost: "132,000円" },
    { size: "３㎡以内", cost: "280,000円", unitCost: "103,500円" },
    { size: "４㎡以内", cost: "330,000円", unitCost: "92,000円" },
    { size: "５㎡以内", cost: "380,000円", unitCost: "80,500円" },
    { size: "それ以上", cost: "要見積り", unitCost: "要見積り" },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 md:p-10 shadow-xl border border-stone-100 mb-16">
      <h3 className="text-2xl font-bold text-stone-800 mb-8 text-center">
        安心定額平米プラン<br />
        (石材撤去処分、コンクリート撤去処分、更地仕上げ、標準基本工事費全て含まれています)
      </h3>

      {/* Tombstone Removal Cost */}
      {/* <div className="mb-8 bg-stone-50 p-6 rounded-xl border border-stone-200">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-lg font-bold text-stone-700">墓石撤去費用</span>
          <span className="text-2xl font-bold text-amber-600">{removalCost}</span>
        </div>
      </div> */}

      {/* Enclosure Removal Cost Table */}
      <div className="mb-8">
        <h4 className="text-lg font-bold text-stone-700 mb-4 border-l-4 border-amber-500 pl-3">
          カロート・外柵の撤去費用
        </h4>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse min-w-[500px]">
            <thead>
              <tr className="bg-stone-100 text-stone-700">
                <th className="p-4 font-bold border-b border-stone-200 whitespace-nowrap">以内広さ</th>
                <th className="p-4 font-bold border-b border-stone-200 whitespace-nowrap">1㎡あたりの費用</th>
                <th className="p-4 font-bold border-b border-stone-200 whitespace-nowrap">費用(税別)</th>
              </tr>
            </thead>
            <tbody>
              {priceData.map((row, index) => (
                <tr key={index} className="border-b border-stone-100 hover:bg-stone-50 transition-colors">
                  <td className="p-4 text-stone-800 font-medium whitespace-nowrap">{row.size}</td>
                  <td className="p-4 text-stone-600 whitespace-nowrap">{row.unitCost}</td>
                  <td className="p-4 text-stone-600 whitespace-nowrap">{row.cost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

                {/* Additional Notes */}
        <div className="bg-stone-50 p-6 rounded-xl border border-stone-200 text-sm text-stone-700 leading-relaxed space-y-4">
          <p>
            表示されている価格には、墓石の解体・撤去処分、お骨の取り出し、墓所敷地の更地化(整地)といった標準的な作業がすべて含まれておりますプランです。
          </p>
          
          <div>
            <p className="font-bold mb-2">【別途御見積りとなるケース】</p>
            <p className="mb-2">下記に該当する場合は、現場の状況を確認させていただき、別途お見積りをご提示させていただきます。</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>メニュープランにない平米数の場合</li>
              <li>搬出入が困難 な墓所(一輪車が通れる道幅がない(50㎝以下)など)</li>
              <li>隣接地と基礎コンクリート又は石材が接している場合(隣接墓所の影響、追加補強工事等)</li>
              <li>墓所状況が特異 な場合(深い基礎(40㎝以上)がある、急傾斜地、墓所まで50m以上距離がある)</li>
            </ul>
          </div>
          
          <p>
            まずはお客様の墓所の状況をお伺いし、最適なプランをご提案いたします。お気軽にご相談ください。
          </p>
        </div>
      </div>

      {/* External Link Button */}
      <div className="text-center mt-10">
        <a
          href="https://tomosibi.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-emerald-600 hover:bg-emerald-500 text-white text-lg font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-emerald-500/30 hover:-translate-y-1 group"
        >
          <span>墓じまい費用を今すぐ算出</span>
          <ExternalLink className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </div>
  );
};

export default PriceTable;
